import {mixins, Pie} from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    let self = this;
    let custom_options = {
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            let name = data.labels[tooltipItem.index];
            let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            value = self.$options.filters.formatPriceExt(value, self.$store.getters.getCustomer.currency_label)
            return name+": "+value;
          }
        }
      }
    }
    this.renderChart(this.chartData, {...this.options, ...custom_options})
  }
}
